import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import SubCategoryFormLayer from "../components/SubCategoryFormLayer";

const SubCategoryFormPage = () => {
    return (
        <MasterLayout>
            <SubCategoryFormLayer />
        </MasterLayout>
    );
};

export default SubCategoryFormPage;
